import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ncyscqimmfltctgqahvn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5jeXNjcWltbWZsdGN0Z3FhaHZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NjM5MDgsImV4cCI6MjA5MTEzOTkwOH0.1eDZ-iTnebEcO09ylHglzNjM2g6Ycxw8inZGCyDjxRM';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);